import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  channels: [],
  channelUnreadCount: {},
  unreadCountState: 0,
  channelDetail: {},
  selectedChannel: {},
  userJwt: '',
  unreadValue: false,
  isChannelReady: false,
  isChannelWindowClosed: true,
  customBadWords: []
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/channel/vuex/index.js